import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  private _cache: Record<string, HttpResponse<any> | undefined> = {};

  store(url: string, response: HttpResponse<any>): void {
    this._cache[url] = response;
  }

  retrieve(url: string): HttpResponse<any> | undefined {
    return this._cache[url];
  }

  invalidateUrl(url: string): void {
    delete this._cache[url];
  }

  invalidateCache(): void {
    this._cache = {};
  }
}
